export const ATTR_DISABLED = 'is-disabled';